import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

/**
 * Basic Game Info (Date, Network)
 */
export const GameInfo = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    border: solid 1px ${({ theme }) => theme.Surface.border};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    justify-content: space-between;
    margin-bottom: 24px;
`;

export const DateNetworkContainer = styled.div<{ $showingBroadcasters: boolean }>`
    display: flex;
    flex-direction: column;

    ${({ $showingBroadcasters }) =>
        $showingBroadcasters &&
        css`
            ${BaseStyle.Mixins.gaps.small}
        `}
`;

export const DateContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10bCaps']}
    color: ${({ theme }) => theme.Text.secondary};

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14bCaps']}
    }
`;

export const NetworkContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const LinksContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
`;

export const LinkContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex: 1;

    ${BaseStyle.Mixins.screenSizes.medium} {
        justify-content: end;
        flex: none;
    }
`;

export const ScoreboardButton = styled.a`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    min-height: 34px;
    padding: 7px 16px;
    justify-content: center;
    align-items: center;
    width: 100%;
    white-space: nowrap;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    background: ${({ theme }) => theme.Surface.primary};
    cursor: pointer;

    && {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
        color: ${({ theme }) => theme.Utility.cta};

        &:hover {
            background: ${({ theme }) => theme.Surface.border};
            color: ${({ theme }) => theme.Utility.cta};
        }
    }

    svg {
        fill: ${({ theme }) => theme.Utility.cta};
        height: 20px;
        width: 20px;
    }
`;

export const ScoreBox = styled.div`
    display: inline-flex;
    align-items: center;
    flex: 1;

    ${BaseStyle.Mixins.screenSizes.large} {
        gap: 32px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        gap: 48px;
    }
`;

export const ScoreContainer = styled.div<{ $isLosingScore: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['32b']}
    // this nightmare works in conjunction with the one in TeamNameContainer up above. this keeps the maximum width 
    // for the score number at 40px but lets it shrink a bit just above that 375px breakpoint to prevent overlaps
    width: clamp(28px, calc((100vw - 375px)/2), 40px);
    text-align: center;
    color: ${({ $isLosingScore, theme }) => ($isLosingScore ? theme.Text.secondary : theme.Text.primary)};

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['24b']}
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['48b']}
        width: 60px;
    }
`;

export const PeriodTimeContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1}
    ${BaseStyle.Mixins.gaps.extraSmall}
    
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.small}
    }
`;

export const SituationDescription = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10bCaps']}
    ${BaseStyle.Mixins.gaps.small}
    

    display: flex;

    * {
        color: ${({ theme }) => theme.Utility.critical};
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14bCaps']}
    }
`;
